export const usePluralize = () => {
	const pluralize = (count, forms) => {
		const normalizedCount = Math.abs(Number(count));

		if (!Array.isArray(forms) || forms.length !== 3) {
			throw new Error("pluralize ожидает массив из 3 форм: [one, few, many]");
		}

		if (Number.isNaN(normalizedCount)) {
			return forms[2];
		}

		const mod100 = normalizedCount % 100;
		const mod10 = normalizedCount % 10;

		if (mod100 >= 11 && mod100 <= 14) {
			return forms[2];
		}

		if (mod10 === 1) {
			return forms[0];
		}

		if (mod10 >= 2 && mod10 <= 4) {
			return forms[1];
		}

		return forms[2];
	};

	const withCount = (count, forms) => `${count} ${pluralize(count, forms)}`;

	return {
		pluralize,
		withCount
	};
};
